/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import ApolloClient from "apollo-boost";
import { Auth } from "@aws-amplify/auth";
import awsConfig from "../awsConfig";

interface CorrelationResponse {
  status?: string;
  token?: string;
}

// Use the ID token (user pool authorizer) for now
const apolloClient = new ApolloClient({
  uri: awsConfig.API.graphql_endpoint,
  request: (operation) =>
    new Promise((resolve, _) => {
      Auth.currentSession().then((session) => {
        const token = session.getIdToken().getJwtToken();
        operation.setContext({ headers: { Authorization: token } });
        resolve();
      });
    }),
});

const fetchCorrelationId = (captcha: string): Promise<CorrelationResponse> => {
  if (!awsConfig.API.correlation_endpoint) {
    return Promise.reject(new Error("Correlation endpoint not defined"));
  }

  return fetch(awsConfig.API.correlation_endpoint, {
    method: "POST",
    body: JSON.stringify({ captcha }),
  })
    .then((res) =>
      res.status !== 200
        ? Promise.reject(new Error(`HTTP Error ${res.statusText}`))
        : res.json()
    )
    .then((json) => ({
      token: json.token,
      status: json.status,
    }))
    .catch((err) => {
      console.error("Error fetching correlation ID", err);
      return Promise.reject(new Error(`Error: ${err}`));
    });
};

export { apolloClient, fetchCorrelationId };
